module.exports = __webpack_public_path__ + "files/94a4c94efc06f4307c96256224e814d1.png";